import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    console.log("El controlador de ofertas se ha conectado.");
  }

}
